import { render } from "./FinancesSideBar.vue?vue&type=template&id=54291538&scoped=true"
import script from "./FinancesSideBar.vue?vue&type=script&lang=js"
export * from "./FinancesSideBar.vue?vue&type=script&lang=js"

import "./FinancesSideBar.vue?vue&type=style&index=0&id=54291538&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54291538"]])

export default __exports__